<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
    stroke-linejoin="round" width="16" height="16">
    <polyline points="6 9 12 15 18 9" />
  </svg>
</template>

<script>
export default {
  name: 'ChevronDownIcon'
}
</script>
